import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "hook", "type"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useMemo } from 'react';
import { isComponent } from "../../util/is-component";
import { CarouselTypeFade } from "./carousel-type-fade";
import { CarouselTypeSlide } from "./carousel-type-slide";
import { TYPES } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var CarouselContext = /*#__PURE__*/React.createContext({});
export var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    hook = _ref.hook,
    type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var carouselProps = _objectSpread(_objectSpread({}, hook), rest);
  var items = React.Children.toArray(children).map(function (child, index) {
    var props = isComponent(child) ? _objectSpread(_objectSpread({}, hook), {}, {
      index: index,
      isCurrent: hook.currentIndex === index
    }) : null;
    return /*#__PURE__*/React.cloneElement(child, props);
  });
  var CarouselType = useMemo(function () {
    return type === TYPES.FADE ? CarouselTypeFade : CarouselTypeSlide;
  }, [type]);
  return /*#__PURE__*/_jsx(CarouselContext.Provider, {
    value: hook,
    children: /*#__PURE__*/_jsx(CarouselType, _objectSpread(_objectSpread({}, carouselProps), {}, {
      children: items
    }))
  });
};
Carousel.defaultProps = {
  type: TYPES.SLIDE
};
Carousel.displayName = 'Carousel';